import { ArrowRight, Calculator, Newspaper } from "lucide-react";
import { Link } from "react-router-dom";

const SUPPORT_CARDS = [
  {
    key: "financials",
    icon: Calculator,
    title: "Financial Planning Tools",
    body: "Compare affordability, loan scenarios, and ownership planning before you commit to the next move.",
    cta: "Explore Financials",
    href: "/financials",
  },
  {
    key: "market-insights",
    icon: Newspaper,
    title: "Market Insights",
    body: "Read district movements, pricing signals, and market perspective without drowning in noise.",
    cta: "Read Insights",
    href: "/insights",
  },
];

export const HomepageDecisionSupportSection = ({ buildBrandedPath }) => (
  <section className="section-shell pt-8" data-testid="homepage-decision-support-section">
    <div className="max-w-3xl">
      <p className="text-xs font-bold uppercase tracking-[0.22em] text-[#8b6d16]">Decision Support</p>
      <h2 className="mt-3 text-4xl font-semibold leading-tight text-[#001935] md:text-5xl" data-testid="homepage-decision-support-heading">
        Financials and market perspective for more confident decisions.
      </h2>
    </div>

    <div className="mt-8 grid gap-5 lg:grid-cols-2" data-testid="homepage-decision-support-grid">
      {SUPPORT_CARDS.map((card) => {
        const Icon = card.icon;
        return (
          <div className="rounded-[30px] border border-[#D7C39A]/36 bg-[#FFFDF7] p-6 shadow-[0_18px_50px_rgba(12,40,90,0.05)]" data-testid={`homepage-${card.key}-card`} key={card.key}>
            <div className="flex h-12 w-12 items-center justify-center rounded-full border border-[#D7C39A]/36 bg-[#FFF4DB] text-[#8b6d16]">
              <Icon className="h-5 w-5" />
            </div>
            <h3 className="mt-5 text-3xl font-semibold leading-tight text-[#0C285A]">{card.title}</h3>
            <p className="mt-4 text-sm leading-8 text-[#42566f] md:text-base">{card.body}</p>
            <Link className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#0C285A]" data-testid={`homepage-${card.key}-cta`} to={buildBrandedPath(card.href)}>
              {card.cta} <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        );
      })}
    </div>
  </section>
);